import styled from 'styled-components';

const alertColors = {
    error: '#ff3333',
};

const Alert = styled.div`
    margin-top: 16px;
    margin-bottom: 16px;
    border: 2px solid ${alertColors.error};
    border-radius: 4px;
    padding: 8px;
    background: ${alertColors.error}20;
    max-width: 400px;
    box-sizing: border-box;
`;

export default Alert;
